<template>
<div>
  <nav class="navbar navbar-expand-lg text-dark bg-white fixed-top">
    <router-link to="/" class="navbar-brand">
        <img
            :src="logo"
            alt="logo"
            class="logo-responsive"
            style="max-height: 40px; max-width: 200px;"
            v-if="logo && logo != '?'"
        />
        <span v-else>
            Portal
        </span>
    </router-link>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">

        <!-- Portal do Apoiado -->
        <template v-if="$store.state.user.st_tipo == 'O'">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <template v-if="is_teste">
                    <router-link class="nav-link" to="/apoio">
                        Início
                    </router-link>
                </template>
                <router-link class="nav-link" to="/apoiocadastro" v-if="$store.state.user.model && $store.state.user.model.fl_cad_portal">
                    Cadastro
                </router-link>
                <router-link class="nav-link" to="/apoioresultados">
                        Pedidos
                </router-link>
                <template v-if="$store.state.user.model && ( $store.state.user.model.st_tipo_acesso == 'S' || $store.state.user.model.st_tipo_acesso == 'P' || $store.state.user.model.st_tipo_acesso == 'T' || $store.state.user.model.fl_portal_download )">
                    <router-link class="nav-link" to="/portaldownload">
                        Download de Resultados
                    </router-link>
                </template>
                <template v-if="1==0 && $store.state.user.model && $store.state.user.model.portal_consultas && $store.state.user.model.portal_consultas.length">
                    <router-link class="nav-link" to="/portalinfo">
                        Informações/Resultados
                    </router-link>
                </template>
                <template v-if="false">
                    <router-link class="nav-link" to="/apoioamostras">
                        Amostras
                    </router-link>
                    <router-link class="nav-link" to="/apoiohelp">
                        Help de Exames
                    </router-link>
                    <router-link class="nav-link" to="/apoioinfo">
                        Informações
                    </router-link>
                </template>
                <template v-if="$store.state.user && $store.state.user.abas && $store.state.user.abas.length">
                    <router-link class="nav-link" :to="'/pa/' + aba.id_apoiado_portal_aba" v-for="(aba, iix) in $store.state.user.abas" :key="iix">
                        {{ aba.search }}
                    </router-link>
                </template>

                <template>
                    <router-link class="nav-link" to="/apoiorelats" v-if="$store.state.user.tem_relat">
                        Relatórios
                    </router-link>
                </template>
            </div>
        </template>

        <template v-else-if="$store.state.user.st_tipo == 'R'">
            <router-link class="nav-link" to="/">
                Resultados
            </router-link>  
            <template v-if="$store.state.user && $store.state.user.abas && $store.state.user.abas.length">
                <router-link class="nav-link" :to="'/pa/' + aba.id_apoiado_portal_aba" v-for="(aba, iix) in $store.state.user.abas" :key="iix">
                    {{ aba.search }}
                </router-link>
            </template>
        </template>

        <template v-else>
            <router-link class="nav-link" to="/" v-if="$store.state.unidade.agendas && $store.state.user.st_tipo != 'R' && $store.state.user.st_tipo != 'O'">
                Agendar
            </router-link>
            <router-link class="nav-link" to="/resultados" v-if="$store.state.user.st_tipo != 'X' && $store.state.user.st_tipo != 'R' && $store.state.unidade.resultados">
                Resultados
            </router-link>
            <router-link class="nav-link" to="/" v-if="$store.state.user.st_tipo == 'O'">
                Lançamento
            </router-link>
            <template v-if="$store.state.user && $store.state.user.abas && $store.state.user.abas.length">
                <router-link class="nav-link" :to="'/pa/' + aba.id_apoiado_portal_aba" v-for="(aba, iix) in $store.state.user.abas" :key="iix">
                    {{ aba.search }}
                </router-link>
            </template>
            <a :href="link_ajuda" target="_blank" class="nav-link" v-if="link_ajuda && $store.state.user.st_tipo != 'R' && $store.state.user.st_tipo != 'O'">
                <i class="fa-solid fa-circle-question"></i>
            </a>
        </template>

        <div class="collapse navbar-collapse" id="navbarSupportedContent" v-if="1==0">
            <ul class="navbar-nav mr-auto">
            <li class="nav-item">
                <router-link class="nav-link" to="/">
                Agendar
                </router-link>
            </li>
            <li class="nav-item" v-if="$store.state.unidade.resultados">
                <router-link class="nav-link" to="/resultados">
                Resultados
                </router-link>
            </li>
            <li class="nav-item" v-if="link_ajuda">
                <a :href="link_ajuda" target="_blank" class="nav-link">
                Ajuda
                </a>
            </li>
            
            </ul>
        </div>

    </div>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <i class="fas fa-bars"></i>
    </button>
    

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      
      <!-- Menu do Usu[ario -->
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown">
          <a id="navbarDropdown" class="nav-link active dropdown-toggle d-flex flex-row align-items-center"
            href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div :data-initials="$store.state.user.initials" data-toggle="tooltip" data-placement="left" 
              :title="$store.state.user.search + ' (' + $store.state.user.st_login + ')'"></div>
            <div class="caret"></div>
          </a>

          <div id="creek-dropdown" class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
            <a class="dropdown-item ddip-card" href="#" @click="verMeusDados ()" v-if="$store.state.user.pessoa && $store.state.user.pessoa.paciente_unidade">Meus Dados</a>
            <a class="dropdown-item ddip-card" href="#" @click="logout ()">Sair</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>

  <!-- Barra Fixa na parte de baixo para celular -->

    <!-- Barra Apoiado -->

    <template v-if="1==0 && $store.state.user.st_tipo == 'O'">

        <nav class="mobile-footer fixed-bottom d-md-none d-flex bg-white">

            <router-link class="mobile-footer-item" to="/apoiocadastro" v-if="$store.state.user.model && $store.state.user.model.fl_cad_portal">
                <div class="mobile-footer-icon">
                    <i class="fa-solid fa-circle-plus"></i>
                </div>
                Cadastro
            </router-link>

            <router-link class="mobile-footer-item" to="/apoioresultados">
                <div class="mobile-footer-icon">
                    <i class="fa-solid fa-file-lines"></i>
                </div>
                Pedidos
            </router-link>

            <template v-if="$store.state.user.model && ( $store.state.user.model.st_tipo_acesso == 'S' || $store.state.user.model.st_tipo_acesso == 'P' || $store.state.user.model.st_tipo_acesso == 'T' || $store.state.user.model.fl_portal_download )">
                <router-link class="mobile-footer-item" to="/portaldownload">
                    <div class="mobile-footer-icon">
                        <i class="fa-solid fa-cloud-arrow-down"></i>
                    </div>
                    Resultados
                </router-link>
            </template>

            <a href="#" class="mobile-footer-item" @click.prevent="logout (true)">
                <div class="mobile-footer-icon">
                    <i class="fa-solid fa-right-from-bracket"></i>
                </div>
                <span>Sair</span>
            </a>

        </nav>
        
    </template>

    <!-- Barra Paciente -->

    <template v-else-if="$store.state.user.st_tipo == 'P' && $store.state.unidade.agendas && $store.state.unidade.resultados">

        <nav class="mobile-footer fixed-bottom d-md-none d-flex bg-white">

            <router-link class="mobile-footer-item" to="/" v-if="$store.state.unidade.agendas && $store.state.user.st_tipo != 'R' && $store.state.user.st_tipo != 'O'">
                <div class="mobile-footer-icon">
                    <i class="fa-regular fa-calendar-plus"></i>
                </div>
                <span>Agendar</span>
            </router-link>
            <router-link class="mobile-footer-item" to="/resultados" v-if="$store.state.user.st_tipo != 'X' && $store.state.user.st_tipo != 'R' && $store.state.unidade.resultados">
                <div class="mobile-footer-icon">
                    <i class="fa-regular fa-file-lines"></i>
                </div>
                <span>Resultados</span>
            </router-link>
            <a :href="link_ajuda" target="_blank" class="mobile-footer-item" v-if="link_ajuda && $store.state.user.st_tipo != 'R' && $store.state.user.st_tipo != 'O'">
                <div class="mobile-footer-icon">
                    <i class="fa-solid fa-circle-question"></i>
                </div>
                <span>Ajuda</span>
            </a>
            <a href="#" class="mobile-footer-item" @click.prevent="verMeusDados()" v-if="false">
                <div class="mobile-footer-icon">
                    <i class="fa-regular fa-user"></i>
                </div>
                <span>Minha conta</span>
            </a>

            <a href="#" class="mobile-footer-item" @click.prevent="logout (true)">
                <div class="mobile-footer-icon">
                    <i class="fa-solid fa-right-from-bracket"></i>
                </div>
                <span>Sair</span>
            </a>

        </nav>
    </template>


  <!-- Modal -->
  <div class="modal fade" id="meusDadosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Meus Dados</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
          <portal-meus-dados ref="meusdados" :marcacao="meus_dados" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          <az-submit @click="atualizar_cadastro()">Atualizar</az-submit>
        </div>
      </div>
    </div>
  </div>

</div>
  
</template>

<script>
import $ from 'jquery';
import PortalMeusDados from './PortalMeusDados.vue';
import AzSubmit from '../util/AzSubmit.vue';

export default {
  props: ['link_ajuda'],

  components: {
    PortalMeusDados,
    AzSubmit,
  },

  computed: { 
    is_teste: function () { 
      return window.redir == 'teste';
    },

    meus_dados: function () { 
      return { 
        paciente: this.$store.state.user.pessoa, 
      };
    },

    logo: function() { 
        return this.$store.state.logo;
    }
  },

  methods: {
    atualizar_cadastro () { 
      this.$refs.meusdados.atualizar();
    },

    verMeusDados () { 
      $('#meusDadosModal').modal('show');
    },

    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },

    logout(confirmar = false) {
        if ( confirmar ) { 
            if ( !confirm('Confirma saída?') ) { 
                return; 
            }
        }

        window.location = "/";
    }
  },
  updated () { 
    $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>

<style scoped>

/* Initials */

[data-initials]:before {
background: black;
color: white;
opacity: 1; 
content: attr(data-initials); 
display: inline-block; 
font-weight: bold; 
border-radius: 50%; 
vertical-align: middle; 
margin-right: 0.5em; 
width: 30px; 
height: 30px; 
line-height: 30px; 
text-align: center; 
}

/* Rodapé Celular */
.mobile-footer {
    display: flex;
    justify-content: space-around;
    align-items: center;

    background: #fff;
    border-top: 1px solid #e0e4e8;

    padding: 12px 8px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));

    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.04);
    z-index: 1030;
}

.mobile-footer-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    text-align: center;
    text-decoration: none !important;

    color: #606a73;
    font-size: 12px;
    font-weight: 400;
}

.mobile-footer-icon {
    width: 54px;
    height: 42px;

    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 30px;
    margin-bottom: 5px;

    font-size: 25px;
}

.mobile-footer-item.active {
    color: #1264a3;
    font-weight: 600;
}

.mobile-footer-item.active .mobile-footer-icon {
    background: #dceefb;
}

.mobile-footer-item:hover {
    color: #1264a3;
}

/* Evita que o rodapé cubra o conteúdo */
@media (max-width: 767.98px) {
    body {
        padding-bottom: calc(100px + env(safe-area-inset-bottom, 0px));
    }
}

</style>